/* eslint no-console:0 */
import Rails from "@rails/ujs"
Rails.start()

import.meta.globEager("@/application/extends/*.js")
import.meta.globEager("@/application/main/index.js")